<template>
  <div ref="dialogRef" role="dialog" class="tw-modal tw-backdrop-blur-sm tw-bg-base-200/30 tw-z-50">
    <div
      class="tw-modal-box tw-w-full tw-max-w-screen-lg tw-mx-auto tw-px-2 tw-flex tw-flex-col tw-py-3 lg:tw-py-14"
      :class="[contentClass]"
    >
      <form method="dialog" v-if="closable" class="tw-absolute tw-right-2 tw-top-2 lg:tw-right-6 lg:tw-top-6 tw-z-50">
        <button
          class="tw-btn tw-btn-xs lg:tw-btn-sm lg:tw-w-10 tw-text-base lg:!tw-text-xl tw-btn-circle tw-btn-ghost"
          @click="visible = false"
        >
          ✕
        </button>
      </form>
      <div
        class="tw-text-primary tw-text-base md:tw-text-lg xl:tw-text-xl tw-font-semibold tw-uppercase tw-text-center tw-leading-relaxed tw-mb-2 tw-min-h-8 tw-flex tw-justify-center tw-items-center lg:tw-mb-10 tw-px-3" v-if="title"
        >{{ title }}</div
      >
      <div class="tw-overflow-y-auto tw-flex-1">
        <slot />
      </div>
    </div>
    <form method="dialog" class="tw-modal-backdrop" v-if="maskClosable">
      <button @click="visible = false">close</button>
    </form>
  </div>
</template>
<script setup lang="ts">
  const dialogRef = ref<HTMLDialogElement | null>(null)
  const visible = defineModel<boolean>({
    default: false,
  })
  const props = withDefaults(
    defineProps<{
      closable?: boolean
      maskClosable?: boolean
      contentClass?: string
      paddingClass?: string
      title?: string
    }>(),
    {
      contentClass: 'tw-rounded-2xl xl:tw-rounded-3xl',
    },
  )

  const close = () => {
    visible.value = false
  }
  const open = () => {
    visible.value = true
  }

  // onMounted(() => {
  //   const dialog = unref(dialogRef)
  //   if (dialog) {
  //     dialog.addEventListener('close', () => {
  //       visible.value = false
  //     })
  //   }
  // })

  watchEffect(() => {
    const dialog = unref(dialogRef)
    if (dialog) {
      if (unref(visible)) {
        ;(dialog as any).setAttribute('open', true)
      } else {
        ;(dialog as any).removeAttribute('open', true)
      }
    }
  })

  defineExpose<{ open: () => void; close: () => void }>({
    close,
    open,
  })
</script>
